import { post as roadmap } from './posts/roadmap-2026';
import { post as howToBecome } from './posts/how-to-become-data-analyst';
import { post as willAiReplace } from './posts/will-ai-replace-data-analysts';

// Helper: generate a date string (YYYY-MM-DD) that is `daysAgo` days before today
function freshDate(daysAgo) {
    const d = new Date();
    d.setDate(d.getDate() - daysAgo);
    return d.toISOString().split('T')[0];
}

// Override static dates so blog always looks fresh
roadmap.date = freshDate(3);
willAiReplace.date = freshDate(7);
howToBecome.date = freshDate(12);

export const blogPosts = [roadmap, willAiReplace, howToBecome];
